import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCaseStudyTime = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 19" {...props}>
    <path
      fill="currentColor"
      d="M7.438 6.254a4.852 4.852 0 0 0-4.844 4.844 4.852 4.852 0 0 0 4.844 4.844 4.852 4.852 0 0 0 4.844-4.844 4.852 4.852 0 0 0-4.844-4.844Zm0 9.144a4.3 4.3 0 1 1 0-8.6 4.3 4.3 0 0 1 0 8.6Zm1.95-11.031v-.744a.424.424 0 0 0 .394-.425V1.042A.432.432 0 0 0 9.35.61H5.525a.432.432 0 0 0-.43.432v2.156a.43.43 0 0 0 .405.425v.744C2.575 5.21.432 7.904.432 11.097a7.011 7.011 0 0 0 7.006 7.007c3.862 0 7.006-3.144 7.006-7.006 0-3.188-2.144-5.881-5.062-6.725l.006-.006Zm-3.431-2.9h2.962V2.76H5.957V1.467Zm.406 2.156h2.162v.55a7.807 7.807 0 0 0-1.08-.094c-.363 0-.72.031-1.076.094v-.55h-.006Zm1.075 13.125a5.663 5.663 0 0 1-5.656-5.656 5.663 5.663 0 0 1 5.656-5.657 5.663 5.663 0 0 1 5.656 5.657 5.663 5.663 0 0 1-5.656 5.656Zm2.2-7.85a.434.434 0 0 1 0 .612l-1.769 1.757v3.237a.432.432 0 0 1-.862 0v-3.412c0-.113.043-.225.125-.307l1.893-1.887a.434.434 0 0 1 .613 0Z"
    />
  </svg>
);

export default SvgCaseStudyTime;
